export const initialState = {};



// WEBPACK FOOTER //
// ./src/constants/InitialState.js